


import { createAsyncThunk, isRejectedWithValue } from "@reduxjs/toolkit";
import ApiBuilder from "@/api/ApiBuilder";
import { InitPaymentForPendingBookingtype, PriceAferCouponAppliedType, rescheduleBookingType } from "@/types/interfaceType";


// Define the expected input type
interface CreateBookingArgs {
    // data: any; // Replace `any` with a proper interface if available

    data:{
        turfId:string,
         sportId:string, courtId:string, date:any, slots:any, offerCode:any, customUserDetails?:any, idempotencyKey:string,
    }
    callback?: (response: any) => void; // Optional callback
    pathparams?: string;

}
interface DBLPlatformOffers{
    pathparams?: string;
    callback?: (response: any) => void; // Optional callback
}

interface initPaymentForPendingBookingArg{
    data: InitPaymentForPendingBookingtype; // Replace `any` with a proper interface if available
    callback?: (response: any) => void; // Optional callback
}

interface verifyPaymentArgs {
    data: any; // Replace `any` with a proper interface if available
    callback?: (response: any) => void; // Optional callback
}

interface getApiParams {
    pathparams?: String;
    token?:string;
    callback
    ?: (response?: any, error?: any) => void;
}

interface PriceAferCouponAppliedTypeArg{
    pathparams?: string;
    data:PriceAferCouponAppliedType,
    callback?: (response: any) => void; // Optional callback

}

interface RescheduleBookingArg{
      pathparams?: string;
      data:rescheduleBookingType,
    callback?: (response: any) => void; // Optiona
}

export const getStaticPaymentFeeDetails = createAsyncThunk(
    "payment/getStaticPaymentFeeDetails",
    async (callback: any, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getStaticPaymentFeeDetails();
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Login failed";
            return rejectWithValue(errorMessage);
        }
    }
);

export const createBooking = createAsyncThunk<any, CreateBookingArgs>(
    "payment/createBooking",
    async ({ data, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.createBooking(data);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Booking creation failed";
            if (callback) {
                callback(error)
            }
            return rejectWithValue(errorMessage);
        }
    }
);

export const DBLcreateBooking = createAsyncThunk<any, CreateBookingArgs>(
    "payment/DBLcreateBooking",
    async ({ data,pathparams, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.DBLcreateBooking(data,pathparams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Booking creation failed";
            if (callback) {
                callback(error)
            }
            return rejectWithValue(errorMessage);
        }
    }
);
export const initPaymentForPendingBooking = createAsyncThunk<any, initPaymentForPendingBookingArg>(
    "payment/initPaymentForPendingBooking",
    async ({ data, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.initPaymentForPendingBooking(data);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Booking creation failed";
            if (callback) {
                callback(error)
            }
            return rejectWithValue(errorMessage);
        }
    }
);


export const cancelBooking = createAsyncThunk<any, getApiParams>(
    "payment/cancelBooking",
    async ({ pathparams, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.cancelBooking(pathparams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Booking Cancellation failed";
            return rejectWithValue(errorMessage);
        }
    }
);


export const cancelPendingBooking = createAsyncThunk<any, getApiParams>(
    "payment/cancelPendingBooking",
    async ({ pathparams, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.cancelPendingBooking(pathparams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Booking Cancellation failed";
            return rejectWithValue(errorMessage);
        }
    }
);






export const verifyPayment = createAsyncThunk<any, verifyPaymentArgs>(
    "payment/verifyPayment",
    async ({ data, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.verifyPayment(data);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Payment verification failed";
            return rejectWithValue(errorMessage);
        }
    }
);

export const getPlatformOffers = createAsyncThunk<any, getApiParams>(
    "pricing/getPlatformOffers",
    async ({pathparams,callback,token=null }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getPlatformOffers(pathparams,token);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Offer fetch failed";
            return rejectWithValue(errorMessage);
        }
    }
);

export const getGlobalPlatformOffers = createAsyncThunk<any, getApiParams>(
    "pricing/getGlobalPlatformOffers",
    async ({callback=null }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getGlobalPlatformOffers();
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error:any) {
            const errorMessage = error?.error || error?.response?.data?.message || error?.message || "Offer fetch failed";
            return rejectWithValue(errorMessage);
        }
    }
);

export const getDBLPlatformOffers = createAsyncThunk<any, getApiParams>(
    "payment/getDBLPlatformOffers",
    async ({pathparams, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getDBLPlatformOffers(pathparams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Offer fetch failed";
            if (callback) {
                callback(error)
            }
            return rejectWithValue(errorMessage);
        }
    }
);

export const previewBookingPriceAferCouponApplied = createAsyncThunk<any, PriceAferCouponAppliedTypeArg>(
    "pricing/previewBookingPriceAferCouponApplied",
    async ({ data , callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.previewBookingPriceAferCouponApplied(data);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            if (callback) {
                callback(error)
            }
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Coupon applied failed";
            return rejectWithValue(errorMessage);
        }
    }
);

export const previewDBLBookingPriceAferCouponApplied = createAsyncThunk<any, PriceAferCouponAppliedTypeArg>(
    "pricing/previewDBLBookingPriceAferCouponApplied",
    async ({ data ,pathparams, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.previewDBLBookingPriceAferCouponApplied(data,pathparams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            if (callback) {
                callback(error)
            }
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Coupon applied failed";
            return rejectWithValue(errorMessage);
        }
    }
);


export const rescheduleBooking = createAsyncThunk<any, RescheduleBookingArg>(
    "booking/rescheduleBooking",
    async ({ data , callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.rescheduleBooking(data);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            if (callback) {
                callback(error)
            }
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Reschedule failed";
            return rejectWithValue(errorMessage);
        }
    }
);





